import React from 'react'

class DataCollectionListMeasurementTableHeader extends React.Component {
  render() {
    return (
      <thead>
        <tr>
          <th colSpan={3}> Specimen</th>
          <th colSpan={6}> Parameters</th>
          <th rowSpan={2}> Average file</th>
        </tr>
        <tr>
          <th> Macromolecule</th>
          <th> Conc</th>
          <th> Buffer</th>
          <th>Exp. Temp.</th>
          <th> Vol. Load</th>
          <th> Trans.</th>
          <th> wait T.</th>
          <th> Flow</th>
          <th> Viscosity</th>
        </tr>
      </thead>
    )
  }
}

export default DataCollectionListMeasurementTableHeader
